export default __webpack_public_path__ + "static/media/Background.af42d587.png";